import React, { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { TextInputProps } from '../../../ana-toolbox'
import { FieldHelperText } from '../field-helper-text/field-helper-text'
import { Translate } from '../translate/translate'

import * as S from './text-input.styles'

export const TextInput = memo(
  ({
    className,
    value,
    required = false,
    label,
    name,
    InputLabelProps,
    placeholder,
    inputComponent,
    helperText,
    error,
    endAdornment,
    ...props
  }: TextInputProps) => {
    const { t } = useTranslation()

    return (
      <>
        <S.TextField
          value={value}
          name={name}
          className={className}
          label={
            <S.Label required={required}>
              <Translate>{label}</Translate>
            </S.Label>
          }
          slotProps={{
            input: {
              inputComponent,
              endAdornment,
            },
            inputLabel: {
              id: `${name}-label`,
              htmlFor: name,
              ...InputLabelProps,
            },
            formHelperText: {
              id: `${name}-helperText`,
            },
            htmlInput: {
              'data-placeholder-translation-key': placeholder,
              'aria-labelledby': `${name}-label`,
              id: name,
            },
          }}
          error={Boolean(error)}
          variant="outlined"
          placeholder={
            placeholder ? t(placeholder) || '' : t(`${label}_placeholder`, { defaultValue: '', postProcess: [] }) || ''
          }
          fullWidth
          {...props}
        />

        <FieldHelperText helperText={helperText} error={error} name={name} />
      </>
    )
  }
)

TextInput.displayName = 'TextInput'
